import { css } from '@/styled-system/css';

export const modalCloseButtonStyles = css.raw({
  insetBlockStart: 'Modal.CloseButton.margin.top',
  insetInlineEnd: 'Modal.CloseButton.margin.right',
  position: 'absolute',
  zIndex: 100,
});
